import { useCallback, useState } from "react";

export function useNotaryMissingContactEmailFormState(): {
	emailInput: string;
	setEmailInput: (v: string) => void;
	error: string | null;
	setError: (e: string | null) => void;
	saving: boolean;
	setSaving: (v: boolean) => void;
} {
	const [emailInput, setEmailInputState] = useState("");
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const setEmailInput = useCallback((v: string) => {
		setEmailInputState(v);
		setError(null);
	}, []);

	return {
		emailInput,
		setEmailInput,
		error,
		setError,
		saving,
		setSaving,
	};
}
